import React from 'react';

const footerStyle = {
  textAlign: 'center',
  padding: '14px',
  fontSize: '0.62rem',
  color: 'var(--subtle)',
  borderTop: '1px solid var(--border)',
  background: 'var(--surface)',
  marginTop: '8px',
};

export default function Footer() {
  return (
    <footer style={footerStyle}>
      Designed and Developed by{' '}
      <a
        href="https://indevconsultancy.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        Indev Consultancy Pvt Ltd
      </a>
    </footer>
  );
}
